import React from "react";
import { useHistory } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";

import styles from "./styles";
import useGlobal from "../../store";

export default function BookingForm() {
	const classes = styles();
    const history = useHistory();
	const [globalState, globalActions] = useGlobal();
	const { resorts } = globalState.homeContext;
	const [startDate, setstartDate] = React.useState(new Date());
	const [endDate, setendDate] = React.useState(new Date());
	const [values, setValues] = React.useState({
		adults: 0,
		kids: 0,
		resort: ""
	});

	const handleChange = name => event => {
		setValues({ ...values, [name]: event.target.value });
	};

	function handleStartDateChange(date) {
		setstartDate(date);
	}
	function handleEndDateChange(date) {
		setendDate(date);
	}

	const handleRoomSearch = async () => {
        
		var sDay = startDate.getDate();
		var sMonth = (startDate.getMonth()+1);
		var sYear = startDate.getFullYear();
		var eDay = endDate.getDate();
		var eMonth = (endDate.getMonth()+1);
		var eYear = endDate.getFullYear();
		var	resort = values.resort;
		var	adults = values.adults;
		var	kids= values.kids;
		var	from_date = sYear + '-' + sMonth + '-' + sDay;
		var	to_date = eYear + '-' + eMonth + '-' + eDay;

        history.push('/roomlist?resort=' + resort + 
            '&adults=' + adults + 
            '&kids=' + kids + 
            '&from_date=' + from_date + 
            '&to_date=' + to_date);

	};

	return (
        <form className={classes.formWrap}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                        variant="outlined"
                        id="date-picker-dialog"
                        label="Check in"
                        format="dd/MM/yyyy"
                        value={startDate}
                        onChange={handleStartDateChange}
                        margin="dense"
                    />
                </FormControl>
                <FormControl variant="outlined" className={classes.formControl}>
                    <KeyboardDatePicker
                        variant="outlined"
                        id="date-picker-dialog"
                        label="Check out"
                        format="dd/MM/yyyy"
                        value={endDate}
                        onChange={handleEndDateChange}
                        variant="outlined"
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Select Resort"
                        className={classes.textField}
                        value={values.resort}
                        onChange={handleChange("resort")}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu
                            }
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                    {resorts && resorts.length && 
                        resorts.map((resort, key) => (
                            <MenuItem key={key} value={resort.slug}>
                                {resort.name}
                            </MenuItem>
                    ))}
                    </TextField>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        id="outlined-adornment-password"
                        variant="outlined"
                        type="text"
                        label="Adults"
                        value={values.adults}
                        onChange={handleChange("adults")}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        id="outlined-adornment-password"
                        variant="outlined"
                        type="text"
                        label="kids"
                        value={values.kids}
                        onChange={handleChange("kids")}
                    />
                </FormControl>
                <Button variant="contained" onClick={handleRoomSearch} className={classes.send}>
                    Search
                </Button>
            </MuiPickersUtilsProvider>
        </form>
	);
}
